import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadGruppenDbListStatus: 'idle',
    loadGruppenDbListError: undefined as any,
    loadGruppenDbListLastArgs: undefined as any,
    loadGruppenDbStatus: 'idle',
    loadGruppenDbError: undefined as any,
    saveGruppenDbStatus: 'idle',
    saveGruppenDbError: undefined as any,
    deleteGruppenDbStatus: 'idle',
    deleteGruppenDbError: undefined as any,

    gruppenDbList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadGruppenDbList = createAsyncThunk('gruppenDbSlice/loadGruppenDbList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().gruppenDbSlice.loadGruppenDbListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/gruppendb/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadGruppenDbListStatus } = getState().gruppenDbSlice
        return loadGruppenDbListStatus !== 'pending'
    }
})

export const loadGruppenDb = createAsyncThunk('gruppenDbSlice/loadGruppenDb', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/gruppendb/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadGruppenDbStatus } = getState().gruppenDbSlice
        return loadGruppenDbStatus !== 'pending'
    }
})

export const saveGruppenDb = createAsyncThunk('gruppenDbSlice/saveGruppenDb', async ({ gruppenDb }: any, { rejectWithValue }: any) => {
    let promises = []
    if (gruppenDb?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/gruppendb/${ gruppenDb?.HDR_ID }/`,
            prepareData(gruppenDb),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/gruppendb/`,
            prepareData(gruppenDb),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveGruppenDbStatus } = getState().gruppenDbSlice
        return saveGruppenDbStatus !== 'pending'
    }
})

export const deleteGruppenDb = createAsyncThunk('gruppenDbSlice/deleteGruppenDb', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/gruppendb/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteGruppenDbStatus } = getState().gruppenDbSlice
        return deleteGruppenDbStatus !== 'pending'
    }
})

const GruppenDbSlice = createSlice({
    name: 'gruppenDbSlice',
    initialState,
    reducers: {
        resetloadGruppenDbListError: (state) => {
            state.loadGruppenDbListError = undefined
        },
        resetloadGruppenDb: (state) => {
            state.formItem = undefined
            state.loadGruppenDbError = undefined
        },
        resetloadGruppenDbError: (state) => {
            state.loadGruppenDbError = undefined
        },
        resetsaveGruppenDb: (state) => {
            state.formItem = undefined
            state.saveGruppenDbError = undefined
        },
        resetsaveGruppenDbError: (state) => {
            state.saveGruppenDbError = undefined
        },
        resetdeleteGruppenDbError: (state) => {
            state.deleteGruppenDbError = undefined
        },
        removeFromGruppenDbListById: (state, action) => {
            state.gruppenDbList = state.gruppenDbList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromGruppenDbListByIds: (state, action) => {
            state.gruppenDbList = state.gruppenDbList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.gruppenDbList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadGruppenDbListStatus = 'preloaded'
            state.loadGruppenDbListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.gruppenDbList = []
            state.loadGruppenDbListStatus = 'idle'
            state.loadGruppenDbListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadGruppenDbList.pending, (state) => {
            state.loadGruppenDbListStatus = 'pending'
            state.loadGruppenDbListError = undefined
        })
        builder.addCase(loadGruppenDbList.fulfilled, (state, action) => {
            state.loadGruppenDbListStatus = 'idle'

            if (!action.payload) { return }

            state.loadGruppenDbListLastArgs = action.payload.args

            {
                state.gruppenDbList = action.payload.data

            }
        })
        builder.addCase(loadGruppenDbList.rejected, (state, action) => {
            state.loadGruppenDbListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadGruppenDbListError = action.error.message
            } else {
                state.loadGruppenDbListError = action.payload
            }
        })

        builder.addCase(loadGruppenDb.pending, (state) => {
            state.loadGruppenDbStatus = 'pending'
            state.loadGruppenDbError = undefined
        })
        builder.addCase(loadGruppenDb.fulfilled, (state, action) => {
            state.loadGruppenDbStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.gruppenDbList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.gruppenDbList.push(newItem) }
                else { state.gruppenDbList[i] = { ...state.gruppenDbList[i], ...newItem } }
            }
        })
        builder.addCase(loadGruppenDb.rejected, (state, action) => {
            state.loadGruppenDbStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadGruppenDbError = action.error.message
            } else {
                state.loadGruppenDbError = action.payload
            }
        })

        builder.addCase(saveGruppenDb.pending, (state) => {
            state.saveGruppenDbStatus = 'pending'
            state.saveGruppenDbError = undefined
        })
        builder.addCase(saveGruppenDb.fulfilled, (state, action) => {
            state.saveGruppenDbStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.gruppenDbList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.gruppenDbList.push(newItem) }
                else { state.gruppenDbList[i] = { ...state.gruppenDbList[i], ...newItem } }
            }
        })
        builder.addCase(saveGruppenDb.rejected, (state, action) => {
            state.saveGruppenDbStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveGruppenDbError = action.error.message
            } else {
                state.saveGruppenDbError = action.payload
            }
        })

        builder.addCase(deleteGruppenDb.pending, (state) => {
            state.deleteGruppenDbStatus = 'pending'
            state.deleteGruppenDbError = undefined
        })
        builder.addCase(deleteGruppenDb.fulfilled, (state, action) => {
            state.deleteGruppenDbStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.gruppenDbList = state.gruppenDbList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.gruppenDbList = state.gruppenDbList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteGruppenDb.rejected, (state, action) => {
            state.deleteGruppenDbStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteGruppenDbError = action.error.message
            } else {
                state.deleteGruppenDbError = action.payload
            }
        })

    }
})

export const {
    resetloadGruppenDbListError,
    resetloadGruppenDb,
    resetloadGruppenDbError,
    resetsaveGruppenDb,
    resetsaveGruppenDbError,
    resetdeleteGruppenDbError,
    removeFromGruppenDbListById,
    removeFromGruppenDbListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = GruppenDbSlice.actions
export default GruppenDbSlice.reducer
